// extracted by mini-css-extract-plugin
export default {"container":"container--jsTw8","icon":"icon--dw14i","title":"title--RBJuo","subtitle":"subtitle--zuY2u","btn":"btn--hcHEy"};